import { useEffect } from 'react'

import { useAppDispatch } from '@/redux/rootReducer'
import { clearNewlyCreatedConsultationId, getStunServer } from '@/redux/reducers/consultation.reducer'
import { getCustomDevices } from '@/redux/reducers/custom-device.reducer'

export function useEmergencyPageSetup() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(clearNewlyCreatedConsultationId())
    dispatch(getStunServer())
    dispatch(getCustomDevices())

    return () => {
      dispatch(clearNewlyCreatedConsultationId())
    }
  }, [dispatch])
}
